import DeliveryMethods from '../mixins/delivery-methods'
export default {
  methods: {
    /**
    * アイコンのパスをドメイン毎に切り替える
    */
    getLogoPath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/logo.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/logo.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/logo.png'
      }
      return ''
    },
    getLogoFooterPath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/logo_footer.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/logo_footer.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/logo_footer.png'
      }
      return ''
    },
    getIcoMenuMypagePath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/ico_menu_mypage.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/ico_menu_mypage.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/ico_menu_mypage.png'
      }
      return ''
    },
    getIcoPagetopPath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/ico_pagetop.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/ico_pagetop.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/ico_pagetop.png'
      }
      return ''
    },
    getIcoModalClosePath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/ico_modal_close.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/ico_modal_close.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/ico_modal_close.png'
      }
      return ''
    },
    getImgLoginVisualPath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/img_login_visual.jpg'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/img_login_visual.jpg'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/img_login_visual.jpg'
      }
      return ''
    },
    getImgLoginCapPath () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/domain1/img_login_cap.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/domain2/img_login_cap.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/domain3/img_login_cap.png'
      }
      return ''
    },
    getImgSelectedClinic () {
      if (DeliveryMethods.DOMAIN === 0) {
        return '../../../../static/img/ico_menu_user.png'
      }
      if (DeliveryMethods.DOMAIN === 1) {
        return '../../../../static/img/ico_menu_user.png'
      }
      if (DeliveryMethods.DOMAIN === 2) {
        return '../../../../static/img/ico_menu_user.png'
      }
      return ''
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ImageUtil.js